
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ProblemApi } from '../api/problem.api';
import { switchMap, map } from 'rxjs/operators';

import { ProblemData, Problem } from '../../../interfaces/masters/problem' ;
@Injectable()
export class ProblemService extends ProblemData {

    constructor(private api: ProblemApi) {
      super();
    }
  
  
    list(url: string): Observable<Problem[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<Problem>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Problem): Observable<Problem[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Problem): Observable<Problem> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  